import { useState } from 'react';
import { Calendar, ArrowLeft } from 'lucide-react';

export function OnboardingStartDay({ onContinue, onSkip, onBack }) {
  const [selectedDay, setSelectedDay] = useState('Monday');
  
  const days = [
    'Monday',
    'Tuesday', 
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday'
  ];

  const handleContinue = () => {
    onContinue({ weekStartDay: selectedDay });
  };

  return (
    <div className="min-h-screen bg-[#F8F7F5] flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        {/* Brand Header */}
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-[#6B7A54] mb-2 text-center">
            Welcome to MealPlan Genie
          </h1>
          <div className="flex items-center justify-center gap-2 text-[#757575]">
            <div className="w-2 h-2 rounded-full bg-primary"></div>
            <div className="w-2 h-2 rounded-full bg-primary"></div>
            <div className="w-2 h-2 rounded-full bg-gray-300"></div>
          </div>
        </div>

        {/* Content Card */}
        <div className="bg-white rounded-3xl shadow-sm p-8">
          {/* Back Button */}
          <button
            onClick={onBack}
            className="flex items-center gap-2 text-[#757575] hover:text-gray-900 transition-colors mb-6"
          >
            <ArrowLeft className="w-4 h-4" />
            <span className="text-sm">Back</span>
          </button>

          {/* Icon */}
          <div className="w-16 h-16 bg-gradient-to-br from-primary/20 to-accent/20 rounded-2xl flex items-center justify-center mx-auto mb-6">
            <Calendar className="w-8 h-8 text-primary" />
          </div>

          {/* Title and Description */}
          <h2 className="text-2xl font-semibold text-center mb-3">
            Choose Your Week Start Day
          </h2>
          <p className="text-[#757575] text-center mb-8">
            You can choose which day of the week your meal plan starts on. You can change this in your preferences later.
          </p>

          {/* Day Selection */}
          <div className="space-y-2 mb-8">
            {days.map((day) => (
              <button
                key={day}
                onClick={() => setSelectedDay(day)}
                className={`w-full px-5 py-4 rounded-2xl text-left transition-all ${
                  selectedDay === day
                    ? 'bg-primary text-[#2D3319] shadow-md'
                    : 'bg-gray-50 hover:bg-gray-100 text-gray-900'
                }`}
              >
                <div className="flex items-center justify-between">
                  <span className="font-medium">{day}</span>
                  {selectedDay === day && (
                    <div className="w-5 h-5 bg-white rounded-full flex items-center justify-center">
                      <div className="w-2.5 h-2.5 bg-primary rounded-full"></div>
                    </div>
                  )}
                </div>
              </button>
            ))}
          </div>

          {/* Action Buttons */}
          <div className="space-y-3">
            <button
              onClick={handleContinue}
              className="w-full py-3 bg-primary text-[#2D3319] rounded-full hover:shadow-lg transition-all font-medium"
            >
              Continue
            </button>
            <button
              onClick={onSkip}
              className="w-full py-3 text-[#757575] hover:text-gray-900 transition-colors font-medium"
            >
              Skip for now
            </button>
          </div>
        </div>

        {/* Progress Text */}
        <p className="text-center text-sm text-[#757575] mt-4">
          Step 2 of 3
        </p>
      </div>
    </div>
  );
}